import {
  CARD,
  CardDefinition,
  IMAGE,
  ImageDefinition,
  LayoutListDefinition,
  LAYOUT_LIST,
  MESSAGE,
  TEXT,
  ADD_NEW_ITEM
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { ItemDefinition } from '../items/Item';
import { ItemIds } from '../items/itemIds';
import { useEditorStore } from '~/shell/Store';

export const Quote7: Translator = sequence => {
  const root = translate(sequence, () => null);
  const messages: ItemDefinition<ItemIds>[] = [];
  const imageList: ItemDefinition<ItemIds>[] = [];

  let isContentEditable = false;
  try {
    const { contentEditable } = useEditorStore.getState();
    isContentEditable = !!contentEditable;
  } catch (e) {
    // ignore if store not available
  }

  sequence.items?.forEach(item => {
    if (item.__typename === 'List') {
      const elementItems = item?.items ? item.items : [];
      elementItems?.forEach(element => {
        const valuesData = element.title ? { sender: element.title } : {};

        messages.push({
          type: MESSAGE,
          id: element.id,
          start: 0,
          values: valuesData,
          items: [
            {
              type: TEXT,
              id: `${element.id}_body`,
              items: [],
              values: {
                value: element.body
              }
            }
          ]
        });
      });

      if (isContentEditable) {
        messages.push({
          type: ADD_NEW_ITEM,
          id: `_add_new_item`,
          items: [],
          values: {
            type: 'text'
          }
        });
      }
    }

    if (item.__typename == 'Text') {
      if (item.pictures && item.pictures?.length) {
        imageList.push({
          id: `${item.id}-pic-wrap`,
          type: LAYOUT_LIST,
          values: {
            orientation: 'column',
            align: 'right'
          },
          items: [
            {
              id: `${item.id}-img`,
              type: IMAGE,
              values: {
                width: '200px',
                url: item.pictures[0].mediaUrl,
                alt: item.pictures[0].name
              }
            } as ImageDefinition
          ]
        } as LayoutListDefinition);
      }
    }
  });

  root.items.push({
    id: `$id-toplist`,
    type: LAYOUT_LIST,
    values: {
      align: 'center',
      orientation: 'row'
    },
    items: [
      {
        id: `$id-llamalist`,
        type: LAYOUT_LIST,
        values: {
          align: 'bottomright',
          orientation: 'row'
        },
        items: []
      },
      {
        id: `$id-cardlist`,
        type: LAYOUT_LIST,
        values: {
          align: 'left',
          orientation: 'row'
        },
        items: [
          {
            id: `$id-card`,
            type: CARD,
            values: {
              height: 'auto',
              width: '600px',
              padded: true
            },
            items: [
              {
                id: `$id-list`,
                type: LAYOUT_LIST,
                values: {
                  align: 'left'
                },
                items: [...messages, ...imageList].filter(Boolean)
              } as LayoutListDefinition
            ]
          } as CardDefinition
        ]
      },
      {
        id: `$id-filler`,
        type: LAYOUT_LIST,
        values: {
          align: 'bottom',
          orientation: 'row'
        }
      }
    ]
  } as LayoutListDefinition);

  return root;
};
